import {Injectable} from '@angular/core';
import {PageInterface} from '../../interfaces/general-interfaces';

@Injectable({
  providedIn: 'root'
})
export class ActivePageHelperService {

  private _activePage: PageInterface | undefined;

  constructor() {
  }
  get activePage(): PageInterface | undefined {
    return this._activePage;
  }

  set activePage(value: PageInterface | undefined) {
    this._activePage = value;
  }
}
